import React from "react";

// Élément dépliable contrôlé (remplace les accordéons Bootstrap/jQuery).
// Le contenu n'est monté que déplié : les vues lourdes (FormViewer…) restent
// paresseuses comme avant. `summary` s'affiche à droite du titre, hors du
// bouton (pas de bouton imbriqué).
const Disclosure = ({ id, title, open = false, onToggle, summary = null, children }) => {
  const buttonId = `${id}-toggle`;
  const regionId = `${id}-panel`;
  return (
    <div className={`disclosure${open ? " is-open" : ""}`}>
      <div className="disclosure__header">
        <button
          type="button"
          id={buttonId}
          className="disclosure__toggle"
          aria-expanded={open}
          aria-controls={regionId}
          onClick={onToggle}
        >
          <i className="fa fa-chevron-down disclosure__chevron" aria-hidden="true" />
          <span>{title}</span>
        </button>
        {summary && <div className="disclosure__summary">{summary}</div>}
      </div>
      <div id={regionId} role="region" aria-labelledby={buttonId} hidden={!open} className="disclosure__panel">
        {open && children}
      </div>
    </div>
  );
};

export default Disclosure;
